import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export function getEstimatedDeliveryTime(
  utcTimestamp,
  isScheduled,
  timezoneId,
) {
  return isScheduled
    ? dayjs(utcTimestamp).tz(timezoneId).format('ddd, MMM D - hh:mm A') // Day, month, date, time
    : dayjs(utcTimestamp).tz(timezoneId).format('hh:mm A'); // Only time
}